var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M443.782-265.869H280q-89.28 0-151.706-62.413-62.425-62.412-62.425-151.546 0-89.134 62.425-152.001Q190.72-694.696 280-694.696h163.782v79.783h-163.54q-56.738 0-95.947 39.069-39.208 39.069-39.208 95.609 0 56.539 39.208 95.844 39.209 39.304 95.947 39.304h163.54v79.218Zm-128.391-180.74v-66.782h329.218v66.782H315.391Zm200.827 180.74v-79.218h163.54q56.738 0 95.947-39.069 39.208-39.069 39.208-95.609 0-56.539-39.208-95.844-39.209-39.304-95.947-39.304h-163.54v-79.783H680q89.099 0 151.898 62.823 62.798 62.823 62.798 151.957 0 89.134-62.798 151.59Q769.099-265.869 680-265.869H516.218Z"
  })));
}
export default SvgLink;